/* istanbul ignore file: We currently do not test jQuery */
'use strict';

$.fn.keyboardNavigation = function(config) {

    var KEY_UP = 38;
    var KEY_DOWN = 40;
    var KEY_RETURN = 13;
    var KEY_ESCAPE = 27;

    var $this = $(this);

    $this.on('keyup.jim-keyboard-nav', function(e){
        if (selecting() && [KEY_UP, KEY_DOWN, KEY_RETURN].includes(e.which)) return;
        if (!selecting() && [KEY_RETURN].includes(e.which)) return;
        config.type($(this));
    });

    $this.on('keydown.jim-keyboard-nav', function(e){
        if (!selecting()) return;
        var index = config.currentIdx();
        if (e.which === KEY_DOWN){
            config.select(clipToRange(index === undefined ? 0 : index+1));
            e.preventDefault();
            return false;
        }
        if (e.which === KEY_UP){
            config.select(clipToRange(index === undefined ? 0 : index-1));
            e.preventDefault();
            return false;
        }
        if (e.which === KEY_RETURN){
            config.complete();
            e.preventDefault();
            return false;
        }
        if (e.which === KEY_ESCAPE){
            config.reset();
            e.preventDefault();
            return false;
        }
    });

    $this.on('blur.jim-keyboard-nav', function(){
        config.complete();
    });

    function clipToRange(index) {
        var range = config.allowedRange();
        if (index < range[0]) index = range[0];
        if (index > range[1]) index = range[1];
        return index;
    }

    /**
     * Whether the user is currently selecting anything
     */
    function selecting(){
        return config.allowedRange();
    }
};

$.fn.keyboardNavigationRemove = function(){
    var $this = $(this);
    $this
        .off('keyup.jim-keyboard-nav')
        .off('keydown.jim-keyboard-nav')
        .off('blur.jim-keyboard-nav');
};
